<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #QuinielaPartidos
    v-layout(align-start='' justify-start='' row='' fill-height='')
      v-flex(xs12 md12 sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png' style='height: auto;width: 80px;border-radius:5px')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Partidos Quiniela
    v-layout(align-start='' justify-start='' row='' wrap='' fill-height='')
      v-flex(xs12 style='margin-top: 5px;display:flex;justify-content:flex-end;padding:0 10px;')
        v-btn(color='blue darken-2' dark='' small='' @click='abrirImportar' style='margin-right:8px;')
          v-icon(left='') cloud_download
          | Importar desde API Mundial
        v-btn(color='#fe0100' dark='' small='' @click='abrirCrear')
          v-icon(left='') add
          | Nuevo Partido
      v-flex(xs12 style='margin-top: 5px;')
        v-card(style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Lista de Partidos
        v-data-table.elevation-1(:headers='headers' :items='partidos' style='margin-top:5px;')
          template(slot='items' slot-scope='props')
            td {{ props.item.fecha | moment('DD/MM/YYYY HH:mm') }}
            td
              div(style='display:flex;align-items:center;gap:6px;')
                img(v-if='props.item.bandera_local' :src='props.item.bandera_local' style='height:22px;')
                span {{ props.item.nombre_local || props.item.equipo_local }}
                span(style='font-weight:bold;margin:0 4px;') vs
                img(v-if='props.item.bandera_visitante' :src='props.item.bandera_visitante' style='height:22px;')
                span {{ props.item.nombre_visitante || props.item.equipo_visitante }}
            td {{ props.item.fase }}
            td {{ props.item.grupo || '—' }}
            td
              span(v-if='props.item.resultado && props.item.resultado.goles_local !== null')
                | {{ props.item.resultado.goles_local }} - {{ props.item.resultado.goles_visitante }}
              span(v-else) Pendiente
            td
              v-chip(:color='colorEstado(props.item.estado)' text-color='white' small='') {{ props.item.estado }}
            td
              v-btn(icon='' @click='editar(props.item)')
                v-icon(color='blue') edit
              v-btn(icon='' @click='abrirResultado(props.item)')
                v-icon(color='green') sports_score
              v-btn(icon='' @click='confirmarEliminar(props.item)')
                v-icon(color='red') delete

  //─── Modal Crear / Editar ───────────────────────────────────────────────────
  v-dialog(v-model='dialog' max-width='600px' persistent='')
    v-card
      v-card-title
        span.headline {{ editando ? 'Editar Partido' : 'Nuevo Partido' }}
      v-card-text
        v-form(ref='form')
          v-layout(wrap='')
            v-flex(xs12 sm6 style='padding-right:8px;')
              v-select(v-model='form.equipo_local' :items='equiposSelect' item-text='label' item-value='codigo' label='Equipo Local' outlined='' dense='' clearable='')
            v-flex(xs12 sm6)
              v-select(v-model='form.equipo_visitante' :items='equiposSelect' item-text='label' item-value='codigo' label='Equipo Visitante' outlined='' dense='' clearable='')
            v-flex(xs12 sm6 style='padding-right:8px;')
              v-text-field(v-model='form.nombre_local' label='Nombre local (eliminatorias)' outlined='' dense='')
            v-flex(xs12 sm6)
              v-text-field(v-model='form.nombre_visitante' label='Nombre visitante (eliminatorias)' outlined='' dense='')
            v-flex(xs12 sm6 style='padding-right:8px;')
              v-select(v-model='form.fase' :items='fases' label='Fase' :rules='[r => !!r || "Requerido"]' outlined='' dense='')
            v-flex(xs12 sm6)
              v-text-field(v-model='form.grupo' label='Grupo' outlined='' dense='')
            v-flex(xs12 sm6 style='padding-right:8px;')
              v-text-field(v-model='form.fecha' label='Fecha (YYYY-MM-DDTHH:mm)' :rules='[r => !!r || "Requerido"]' outlined='' dense='')
            v-flex(xs12 sm6)
              v-text-field(v-model.number='form.orden' label='Orden (id externo)' type='number' outlined='' dense='')
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialog = false') Cancelar
        v-btn(color='#fe0100' dark='' @click='guardar' :loading='loading') Guardar

  //─── Modal Resultado ────────────────────────────────────────────────────────
  v-dialog(v-model='dialogResultado' max-width='400px' persistent='')
    v-card
      v-card-title
        span.headline Registrar Resultado
      v-card-text
        div(v-if='partidoResultado' style='margin-bottom:12px;')
          strong {{ partidoResultado.nombre_local || partidoResultado.equipo_local }} vs {{ partidoResultado.nombre_visitante || partidoResultado.equipo_visitante }}
        v-layout(wrap='')
          v-flex(xs6 style='padding-right:8px;')
            v-text-field(v-model.number='resultado.goles_local' label='Goles Local' type='number' outlined='' dense='')
          v-flex(xs6)
            v-text-field(v-model.number='resultado.goles_visitante' label='Goles Visitante' type='number' outlined='' dense='')
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialogResultado = false') Cancelar
        v-btn(color='green' dark='' @click='guardarResultado' :loading='loading') Guardar y calcular puntos

  //─── Modal Importar ─────────────────────────────────────────────────────────
  v-dialog(v-model='dialogImportar' max-width='850px' persistent='')
    v-card
      v-card-title
        span.headline Importar Partidos desde API
        v-spacer
        v-progress-circular(v-if='loadingApi' indeterminate='' color='blue' size='24')
      v-card-text
        div(v-if='!partidosApi.length && !loadingApi' style='text-align:center;padding:30px;')
          span No se obtuvieron datos de la API.
        div(v-if='partidosApi.length')
          v-layout(align-center='' wrap='')
            v-flex(xs12 sm4 style='padding-right:8px;')
              v-select(v-model='filtroFase' :items='["Todos", ...fases]' label='Filtrar por fase' outlined='' dense='')
            v-flex(xs12 style='margin-bottom:8px;')
              v-btn(small='' text='' @click='selTodosPartidos') Seleccionar todos
              v-btn(small='' text='' @click='deselTodosPartidos' style='margin-left:4px;') Deseleccionar
            v-flex(xs12)
              v-data-table(:headers='headersApi' :items='partidosApiFiltrados' hide-actions='')
                template(slot='items' slot-scope='props')
                  td
                    v-checkbox(v-model='seleccionados' :value='props.item' hide-details='' style='margin:0;')
                  td {{ props.item.fecha | moment('DD/MM/YYYY HH:mm') }}
                  td
                    div(style='display:flex;align-items:center;gap:4px;')
                      img(v-if='props.item.bandera_local' :src='props.item.bandera_local' style='height:18px;')
                      span {{ props.item.nombre_local }}
                      span  vs 
                      img(v-if='props.item.bandera_visitante' :src='props.item.bandera_visitante' style='height:18px;')
                      span {{ props.item.nombre_visitante }}
                  td {{ props.item.fase }}
                  td {{ props.item.grupo || '—' }}
                  td
                    v-chip(:color="props.item._existe ? 'orange' : 'green'" text-color='white' small='')
                      | {{ props.item._existe ? 'Ya existe' : 'Nuevo' }}
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialogImportar = false') Cancelar
        v-btn(color='blue darken-2' dark='' @click='importarSeleccionados' :loading='loading' :disabled='!seleccionados.length') Importar ({{ seleccionados.length }})

  //─── Confirmar Eliminar ─────────────────────────────────────────────────────
  v-dialog(v-model='dialogEliminar' max-width='360px')
    v-card
      v-card-title
        span.headline Confirmar
      v-card-text ¿Eliminar este partido?
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialogEliminar = false') Cancelar
        v-btn(color='red' dark='' @click='eliminar' :loading='loading') Eliminar

  //─── Waiting ────────────────────────────────────────────────────────────────
  v-dialog(v-model='dialog4' persistent='' max-width='400px')
    v-container(style='max-width:400px;background:#f1f2f1;')
      div(style='margin-top:20px;')
        v-flex(xs12)
          v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
            v-flex(xs12)
              v-card-title(style='padding:7px;').justify-center
                h4.black--text Esperando Respuesta del Servidor.!!
            v-flex(xs12)
              div(style='display:flex;justify-content:center;').text-xs-center
                img(src='../assets/waiting.gif' width='200' height='150')
            v-flex(xs12)
              v-card-title(style='padding:7px;').justify-center
                h5.black--text Por favor espere...
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'QuinielaPartidos',
  data: () => ({
    partidos: [],
    equipos: [],
    dialog: false,
    dialogResultado: false,
    dialogImportar: false,
    dialogEliminar: false,
    dialog4: false,
    loading: false,
    loadingApi: false,
    editando: false,
    itemEliminar: null,
    partidoResultado: null,
    resultado: { goles_local: 0, goles_visitante: 0 },
    partidosApi: [],
    seleccionados: [],
    filtroFase: 'Todos',
    fases: ['grupos', 'octavos', 'cuartos', 'semis', 'tercer_puesto', 'final'],
    mapaFases: { group: 'grupos', r32: 'octavos', r16: 'octavos', qf: 'cuartos', sf: 'semis', third: 'tercer_puesto', final: 'final' },
    form: {
      equipo_local: '',
      equipo_visitante: '',
      nombre_local: '',
      nombre_visitante: '',
      fase: 'grupos',
      grupo: '',
      fecha: '',
      orden: 0
    },
    headers: [
      { text: 'Fecha', value: 'fecha' },
      { text: 'Partido', sortable: false },
      { text: 'Fase', value: 'fase' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Resultado', sortable: false },
      { text: 'Estado', value: 'estado' },
      { text: 'Acciones', sortable: false }
    ],
    headersApi: [
      { text: '', sortable: false },
      { text: 'Fecha', sortable: false },
      { text: 'Partido', sortable: false },
      { text: 'Fase', sortable: false },
      { text: 'Grupo', sortable: false },
      { text: 'Estado', sortable: false }
    ]
  }),
  computed: {
    equiposSelect () {
      return this.equipos.filter(e => e.activo).map(e => ({
        codigo: e.codigo,
        label: `${e.codigo} — ${e.nombre}`
      }))
    },
    partidosApiFiltrados () {
      if (this.filtroFase === 'Todos') return this.partidosApi
      return this.partidosApi.filter(p => p.fase === this.filtroFase)
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      Api.get('quiniela/partidos').then(res => { this.partidos = res.data || [] })
      Api.get('quiniela/equipos').then(res => { this.equipos = res.data || [] })
    },
    colorEstado (estado) {
      return { pendiente: 'grey', en_juego: 'orange', finalizado: 'green' }[estado] || 'grey'
    },
    abrirCrear () {
      this.editando = false
      this.form = { equipo_local: '', equipo_visitante: '', nombre_local: '', nombre_visitante: '', fase: 'grupos', grupo: '', fecha: '', orden: 0 }
      this.dialog = true
    },
    editar (item) {
      this.editando = true
      this.form = {
        _id: item._id,
        equipo_local: item.equipo_local,
        equipo_visitante: item.equipo_visitante,
        nombre_local: item.nombre_local,
        nombre_visitante: item.nombre_visitante,
        fase: item.fase,
        grupo: item.grupo,
        fecha: item.fecha ? item.fecha.substring(0, 16) : '',
        orden: item.orden
      }
      this.dialog = true
    },
    guardar () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      const payload = Object.assign({}, this.form)
      const req = this.editando
        ? Api.put('quiniela/partidos', payload)
        : Api.post('quiniela/partidos', payload)
      req.then(() => {
        this.dialog = false
        this.initialize()
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al guardar', 'error')
      }).finally(() => { this.loading = false })
    },
    abrirResultado (item) {
      this.partidoResultado = item
      this.resultado = {
        goles_local: (item.resultado && item.resultado.goles_local != null) ? item.resultado.goles_local : 0,
        goles_visitante: (item.resultado && item.resultado.goles_visitante != null) ? item.resultado.goles_visitante : 0
      }
      this.dialogResultado = true
    },
    guardarResultado () {
      this.loading = true
      Api.post('quiniela/partidos/resultado', {
        partido_id: this.partidoResultado._id,
        resultado: this.resultado
      }).then(res => {
        this.dialogResultado = false
        this.initialize()
        this.$swal('Listo', `Puntos calculados para ${res.data.apuestas_calculadas} apuestas`, 'success')
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al guardar resultado', 'error')
      }).finally(() => { this.loading = false })
    },
    confirmarEliminar (item) {
      this.itemEliminar = item
      this.dialogEliminar = true
    },
    eliminar () {
      this.loading = true
      Api.delete('quiniela/partidos/' + this.itemEliminar._id).then(() => {
        this.dialogEliminar = false
        this.initialize()
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al eliminar', 'error')
      }).finally(() => { this.loading = false })
    },
    parseLocalDate (str) {
      const [datePart, timePart] = str.split(' ')
      const [mm, dd, yyyy] = datePart.split('/')
      return `${yyyy}-${mm}-${dd}T${timePart}:00`
    },
    abrirImportar () {
      this.partidosApi = []
      this.seleccionados = []
      this.filtroFase = 'Todos'
      this.dialogImportar = true
      this.loadingApi = true
      Api.get('quiniela/partidos/fetch-api').then(res => {
        const games = res.data.games || res.data || []
        this.partidosApi = games.map(g => {
          const fase = this.mapaFases[g.type] || 'grupos'
          const eqLocal = this.equipos.find(e => e.codigo === g.home_team_code)
          const eqVisit = this.equipos.find(e => e.codigo === g.away_team_code)
          const payload = {
            equipo_local: g.home_team_code || 'TBD',
            equipo_visitante: g.away_team_code || 'TBD',
            nombre_local: fase === 'grupos' ? (g.home_team_name_en || g.home_team_code) : (g.home_team_label || g.home_team_name_en || 'TBD'),
            nombre_visitante: fase === 'grupos' ? (g.away_team_name_en || g.away_team_code) : (g.away_team_label || g.away_team_name_en || 'TBD'),
            bandera_local: eqLocal ? eqLocal.bandera_url : '',
            bandera_visitante: eqVisit ? eqVisit.bandera_url : '',
            fase,
            grupo: g.group || '',
            fecha: this.parseLocalDate(g.local_date),
            orden: parseInt(g.id),
            _existe: this.partidos.some(p => p.orden === parseInt(g.id)),
            _id_existente: (this.partidos.find(p => p.orden === parseInt(g.id)) || {})._id
          }
          return payload
        })
        this.seleccionados = this.partidosApi.slice()
      }).catch(() => {
        this.$swal('Error', 'No se pudo conectar con la API externa', 'error')
        this.dialogImportar = false
      }).finally(() => { this.loadingApi = false })
    },
    selTodosPartidos () { this.seleccionados = this.partidosApiFiltrados.slice() },
    deselTodosPartidos () { this.seleccionados = [] },
    importarSeleccionados () {
      this.loading = true
      const ops = this.seleccionados.map(g => {
        const payload = {
          equipo_local: g.equipo_local,
          equipo_visitante: g.equipo_visitante,
          nombre_local: g.nombre_local,
          nombre_visitante: g.nombre_visitante,
          bandera_local: g.bandera_local,
          bandera_visitante: g.bandera_visitante,
          fase: g.fase,
          grupo: g.grupo,
          fecha: g.fecha,
          orden: g.orden
        }
        if (g._existe && g._id_existente) {
          return Api.put('quiniela/partidos', { ...payload, _id: g._id_existente })
        } else {
          return Api.post('quiniela/partidos', payload)
        }
      })
      Promise.all(ops).then(() => {
        this.dialogImportar = false
        this.initialize()
        this.$swal('Listo', `${ops.length} partidos importados correctamente`, 'success')
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al importar', 'error')
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
